module.exports = "/_next/static/images/illustration-career-f46df65dd56294f3c0b5b9cec66f04e0.png";